// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"101":"85b60de8","150":"a274f7e1","154":"779915bf","201":"1b3f6d98","231":"162c1ae0","395":"f03f9ef9","642":"c9009fc4","858":"144d78f3","904":"0c5b3ea9","973":"3da867ec"}[chunkId] + ".chunk.js";
};